import InteractionsTable from "components-for/interactions/interactions-table";
import InteractionsTableDateTimeColumn from "components-for/interactions/interactions-table-date-time-column";
import InteractionsTableMessageColumn from "components-for/interactions/interactions-table-message-column";
import InteractionsTableMetricsColumn from "components-for/interactions/interactions-table-metrics-column";
import InteractionsTableSentimentColumn from "components-for/interactions/interactions-table-sentiment-column";
import { FunctionComponent, memo } from "react";
import { IProps } from "./agent-interactions.types";
import { SpinnerUntil } from "@edgetier/components";
import { useAgentFirstName } from "hooks-for/agents/use-agent-first-name";
import { useQueryParameters } from "@edgetier/client-components";
import "./agent-interactions.scss";

/**
 * Interactions the agent has handled.
 * @param props.defaultEndDateTime   Default closing date in the range to search.
 * @param props.defaultStartDateTime Default opening date in the range to search.
 * @returns                          Table of sample interactions.
 */
const AgentInteractions: FunctionComponent<IProps> = ({ defaultEndDateTime, defaultStartDateTime }) => {
    const { reviewAgentId } = useQueryParameters({ reviewAgentId: String });

    // Get the agent's name for the title etc.
    const { data: agentFirstName, isLoading: isAgentFirstNameLoading } = useAgentFirstName(reviewAgentId);

    return (
        <SpinnerUntil<string> data={agentFirstName} isReady={!isAgentFirstNameLoading}>
            {(name) => (
                <InteractionsTable
                    areWritingIssuesVisible={true}
                    mandatoryParameters={{ agentId: [reviewAgentId] }}
                    title={`${name}'s Interactions`}
                >
                    <InteractionsTableDateTimeColumn />
                    <InteractionsTableMessageColumn />
                    <InteractionsTableSentimentColumn />
                    <InteractionsTableMetricsColumn />
                </InteractionsTable>
            )}
        </SpinnerUntil>
    );
};

export default memo(AgentInteractions);
